export function deepClone(obj) {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (ex) {
    return null;
  }
}
export const removeEmpty = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
    if (
      (!obj[key] && obj[key] !== 0) ||
      (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)
    ) {
      delete obj[key];
    }
  });
  return obj;
};
